import * as React from "react";
import "./CancelCreditCard.scss";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import { oneLink } from "../../shared/oneLink";
import AnchorButton from "../../components/AnchorButton";

const CancelCreditCard = () => {
    return (
        <div className="user-action-area">
            <p className="finish-message">
                有料会員プランを停止しました。
                <br />
                サービスは次回更新日までご利用いただけます。
            </p>
            <div className="user-action">
                <AnchorButton href={oneLink()}>アプリを開く</AnchorButton>
                <LinkButton color="secondary" to={URL_PATHS.myPage()}>
                    マイページへ
                </LinkButton>
            </div>
        </div>
    );
};

export default CancelCreditCard;
